import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { BadgeCheck, MapPinIcon, StarIcon } from 'lucide-react';
interface Notification {
  firstName: string;
  lastName: string;
  province: string;
  timeAgo: string;
}
const NOTIFICATIONS: Notification[] = [{
  firstName: 'María',
  lastName: 'González',
  province: 'Córdoba',
  timeAgo: '3 min'
}, {
  firstName: 'Juan',
  lastName: 'Rodríguez',
  province: 'Buenos Aires',
  timeAgo: '7 min'
}, {
  firstName: 'Lucía',
  lastName: 'Fernández',
  province: 'Rosario',
  timeAgo: '12 min'
}, {
  firstName: 'Carlos',
  lastName: 'Martínez',
  province: 'Mendoza',
  timeAgo: '15 min'
}, {
  firstName: 'Ana',
  lastName: 'López',
  province: 'Tucumán',
  timeAgo: '18 min'
}, {
  firstName: 'Pablo',
  lastName: 'García',
  province: 'Santa Fe',
  timeAgo: '22 min'
}, {
  firstName: 'Valentina',
  lastName: 'Díaz',
  province: 'La Plata',
  timeAgo: '25 min'
}, {
  firstName: 'Diego',
  lastName: 'Sánchez',
  province: 'Salta',
  timeAgo: '30 min'
}, {
  firstName: 'Florencia',
  lastName: 'Ruiz',
  province: 'Neuquén',
  timeAgo: '35 min'
}, {
  firstName: 'Martín',
  lastName: 'Pérez',
  province: 'Chaco',
  timeAgo: '40 min'
}];
export function SocialProofPopup() {
  const [currentNotification, setCurrentNotification] = useState<Notification | null>(null);
  useEffect(() => {
    const initialTimeout = setTimeout(() => {
      showRandomNotification();
    }, 5000);
    return () => clearTimeout(initialTimeout);
  }, []);
  const showRandomNotification = () => {
    const randomIdx = Math.floor(Math.random() * NOTIFICATIONS.length);
    setCurrentNotification(NOTIFICATIONS[randomIdx]);
    setTimeout(() => {
      setCurrentNotification(null);
      const nextDelay = Math.floor(Math.random() * 3000) + 5000;
      setTimeout(showRandomNotification, nextDelay);
    }, 4000);
  };
  return <AnimatePresence data-id="element-433">
      {currentNotification && <motion.div initial={{
      opacity: 0,
      y: 30,
      scale: 0.95
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.95
    }} transition={{
      type: 'spring',
      stiffness: 400,
      damping: 25
    }} className="fixed bottom-3 left-3 z-50 bg-white rounded-lg shadow-[0_4px_20px_rgba(249,115,22,0.3)] border-2 border-orange-400 p-2.5 pr-4 max-w-[260px]" data-id="element-434">
          {/* Verified badge - top right corner */}
          <div className="absolute -top-1.5 -right-1.5 flex items-center gap-0.5 bg-orange-500 text-white text-[9px] font-bold px-1.5 py-0.5 rounded-full shadow-md" data-id="element-435">
            <BadgeCheck className="w-3 h-3" data-id="element-436" />
            <span data-id="element-437">Verificado</span>
          </div>

          <div className="flex items-center gap-2" data-id="element-438">
            {/* Avatar with initials */}
            <div className="w-8 h-8 rounded-full bg-gradient-to-br from-orange-400 to-orange-600 flex items-center justify-center text-white text-xs font-bold flex-shrink-0 shadow-sm" data-id="element-439">
              {currentNotification.firstName[0]}
              {currentNotification.lastName[0]}
            </div>

            <div className="min-w-0" data-id="element-440">
              {/* Name - highlighted */}
              <p className="text-sm font-bold text-gray-900 leading-tight truncate" data-id="element-441">
                {currentNotification.firstName} {currentNotification.lastName}
              </p>

              {/* Stars + Province */}
              <div className="flex items-center gap-1.5 mt-0.5" data-id="element-442">
                <span className="flex items-center gap-px" data-id="element-443">
                  {[1, 2, 3, 4, 5].map(s => <StarIcon key={s} className="w-2.5 h-2.5 text-yellow-400 fill-yellow-400" data-id="element-444" />)}
                </span>
                <span className="flex items-center gap-0.5 text-[11px] text-orange-500 font-semibold leading-tight" data-id="element-445">
                  <MapPinIcon className="w-3 h-3 flex-shrink-0" data-id="element-446" />
                  {currentNotification.province}
                </span>
              </div>

              {/* Action text */}
              <p className="text-[10px] text-gray-500 leading-tight mt-0.5" data-id="element-447">
                Compró el Kit de Turismo · hace {currentNotification.timeAgo}
              </p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}